import { Fragment, ReactNode, useEffect } from 'react';

type PopoverProps = {
  id: string;
  children: ReactNode;
  className?: string;
  align?: 'left' | 'right'; // If Popover should be aligned to the left or right of the trigger element
};

const initializeCSSAnchorPolyfill = () => {
  let initialized = false;
  return () => {
    if (initialized) return;
    initialized = true;

    if (!('anchorName' in document.documentElement.style)) {
      const script = document.createElement('script');

      script.src = 'https://unpkg.com/@oddbird/css-anchor-positioning@0.10.1';
      script.type = 'text/javascript';
      script.onerror = (error) => {
        console.error('Failed to load CSS Anchor Positioning polyfill:', error);
      };
      document.body.appendChild(script); // Append the script to the document
    }
  };
};

const Popover = ({ id, children, className, align }: PopoverProps) => {
  useEffect(() => {
    const initializeCSSAnchor = initializeCSSAnchorPolyfill();
    initializeCSSAnchor();
  }, []);

  return (
    <Fragment>
      <style>
        {`
        .trigger-${id} {
          anchor-name: --${id};
        }
        .popover-${id} {
          position: fixed;
          margin: 0;
          border: none;
          padding: 0;
          background: none;
          box-shadow: 0px 1px 3px rgba(0, 26, 51, 0.1);
          inset: auto;
          top: calc(anchor(bottom) + 8px);
					 ${align === 'right' ? 'left: anchor(left); right: auto;' : 'right: anchor(right);'}
          position-anchor: --${id};
        }

        .popover-${id}:popover-open {	
          display: block;
        }	

        `}
      </style>
      {/*// @ts-ignore - popover is not supported */}
      <div id={id} popover="auto" className={`popover-${id} ${className} rounded-lg shadow`}>
        {children}
      </div>
    </Fragment>
  );
};

export default Popover;
